export default class FiltroModelliContratti{

    SitoIntervento;
    StatoIntervento;

    constructor(statoIntervento,sitoIntervento){
        this.SitoIntervento = sitoIntervento;
        this.StatoIntervento = statoIntervento;
    }
}